import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";

export const provideMatDialogInitializer = (): EnvironmentProviders => {
  return provideEnvironmentInitializer(() => {
    const router = inject(Router);
    const dialogRef = inject(MatDialog);

    // Closes all dialogs when pages are navigated away from
    router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        dialogRef.closeAll();
      });
  });
};
